var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"text-center col-12"},_vm._l((_vm.l),function(loc){return _c('a',{attrs:{"href":'/'+loc.locale}},[_c('span',{staticClass:"flag"},[_vm._v(_vm._s(_vm.getFlagEmoji(loc.locale)))])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0453df9a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widget/locale.vue
// module id = BHjL
// module chunks = 1